import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDown16 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 6,
	viewBox: "0 0 10 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.69702 0.75H1.30298C0.844737 0.75 0.627889 1.3151 0.968497 1.62165L4.66552 4.94897C4.85567 5.1201 5.14433 5.1201 5.33448 4.94897L9.0315 1.62165C9.37211 1.3151 9.15526 0.75 8.69702 0.75Z",
		fill: "black"
	})
});
export default SvgDown16;
